import { withErrorBoundary } from 'app/components/error-boundary';
import { withDashboardLayout } from 'app/hooks/with-dashboard-layout';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { LandingPageScreenComponent } from './landing-page-screen-component.large';

export const LandingPageScreen: NavigationScreen<'landing-page'> = withOptionalMetrics(
  'LandingPageScreen',
  withErrorBoundary(withDashboardLayout(LandingPageScreenComponent, 'explorer', true)),
);
